import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDeviceStore = defineStore(
  'ap.device',
  () => {
    const fingerprint = ref<string | null>(null);

    const setFingerprint = (value?: string | null) => {
      fingerprint.value = value ?? null;
    };

    return {
      fingerprint,
      setFingerprint,
    };
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
);
